/* eslint-disable no-undef */
export const URL_API = process.env.REACT_APP_URL_API;
export const URL_CRAW_API = process.env.REACT_APP_URL_CRAW_API;
export const URL_AUTH_API = process.env.REACT_APP_URL_AUTH_API;
export const URL_BASE_API = process.env.REACT_APP_URL_BASE_API;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
export const NODE_ENV = process.env.NODE_ENV;
